import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.82187 11.422C8.99247 11.5304 9.21154 11.5254 9.37703 11.4094C9.54252 11.2934 9.62189 11.0891 9.57816 10.8918L8.82079 7.47442L11.3369 5.17998C11.4834 5.04635 11.5372 4.83874 11.4738 4.65081C11.4105 4.46287 11.242 4.33015 11.0445 4.31251L7.75445 4.01869L6.46382 0.81325C6.38761 0.623978 6.20404 0.5 6 0.5C5.79596 0.5 5.61239 0.623978 5.53618 0.81325L4.24555 4.01869L0.955524 4.31251C0.757988 4.33015 0.589549 4.46287 0.526197 4.65081C0.462845 4.83874 0.516555 5.04635 0.663097 5.17998L3.17921 7.47442L2.42184 10.8918C2.37811 11.0891 2.45748 11.2934 2.62297 11.4094C2.78846 11.5254 3.00753 11.5304 3.17813 11.422L6 9.62922L8.82187 11.422Z",
		fill: "#C0C0C0",
		stroke: "white",
		strokeLinejoin: "round"
	})
});
export default SvgIconStar;
